import { type RadioGroupState } from '@react-stately/radio';
import { createContext, useContext } from 'react';

import { type RadioProps } from '../radio/Radio';

export interface RadioGroupContextValue {
  state: RadioGroupState | null;
  color: RadioProps['color'];
  size?: RadioProps['size'];
  iconPosition?: RadioProps['iconPosition'];
  alignIcon?: RadioProps['alignIcon'];
}

export const RadioGroupContext = createContext<RadioGroupContextValue>({
  state: null,
  color: 'primary',
  size: 'md',
  iconPosition: 'left',
  alignIcon: 'start',
});

export const useRadioGroupContext = () => useContext(RadioGroupContext);
